import React, { useState, useEffect } from "react";
import { Box, Button, Container, TextField, Typography, CircularProgress, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

import { Helmet } from "react-helmet-async";

function Login() {
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const auth = getAuth();

    const [id, setId] = useState("");
    const [ps, setPs] = useState("");

    const [error, setError] = useState({
        id: "",
        ps: "",
        submit: "",
    });

    const handleIDChange = (e) => {
        setId(e.target.value.replace(/[^a-zA-Z0-9@.-]/g, ""));
    };
    const handleIDBlur = () => {
        if (id === "") {
            setError({ ...error, id: "メールアドレスを入力してください" });
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(id)) {
            setError({ ...error, id: "有効なメールアドレスを入力してください" });
        } else {
            setError({ ...error, id: "" });
        }
    };

    const handlePsChange = (e) => {
        setPs(e.target.value.replace(/[^a-zA-Z0-9!@#$%^&*(),.?":{}|<>]/g, ""));
    };
    const handlePsBlur = () => {
        if (ps === "") {
            setError({ ...error, ps: "パスワードを入力してください" });
        } else {
            setError({ ...error, ps: "" });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const errors = {
            id: "",
            ps: "",
            submit: "",
        };
        let isError = false;

        if (id === "") {
            errors.id = "メールアドレスを入力してください";
            isError = true;
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(id)) {
            errors.id = "有効なメールアドレスを入力してください";
            isError = true;
        }

        if (ps === "") {
            errors.ps = "パスワードを入力してください";
            isError = true;
        }

        setError(errors);

        if (isError) {
            return;
        }

        signInWithEmailAndPassword(auth, id, ps)
            .then(() => {
                window.scrollTo(0, 0);
                navigate("/");
            })
            .catch((error) => {
                setError({ ...error, submit: "ログインに失敗しました" });
            });
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                window.scrollTo(0, 0);
                navigate("/", { replace: true });
            }
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>Login - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                <Box
                    component="form"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: 300,
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                    onSubmit={handleSubmit}
                >
                    <Typography variant="h6" sx={{ textAlign: "center", mb: 2 }}>
                        ログイン
                    </Typography>
                    <TextField label="ID" value={id} onChange={handleIDChange} onBlur={handleIDBlur} error={!!error.id} margin="normal" />
                    {error.id && <Alert severity="error">{error.id}</Alert>}
                    <TextField
                        type="password"
                        label="パスワード"
                        value={ps}
                        onChange={handlePsChange}
                        onBlur={handlePsBlur}
                        error={!!error.ps}
                        margin="normal"
                    />
                    {error.ps && <Alert severity="error">{error.ps}</Alert>}
                    {error.submit && (
                        <Alert severity="error" sx={{ mt: 1 }}>
                            {error.submit}
                        </Alert>
                    )}
                    <Button onClick={handleSubmit} variant="contained" sx={{ mt: 2 }} type="submit">
                        ログイン
                    </Button>
                </Box>
            </Container>
        </div>
    );
}

export default Login;
